/**
 * @file 各平台的配置文件
*/
import _ from 'lodash';

const defaultConfig = {
    name: 'default',
    background: '#CDCFDB',
    title: '医渡云预测模型云平台',
};

const configs = [
    {
        name: 'gzzoc',
        background: '#063a7a',
        title: '中山大学中山眼科中心',
        // 后续有其它条件
        checked: /.*/.test(location.host)
    }
];

let config = defaultConfig;

_.forEach(configs, conf => {
    if (conf.checked) {
        config = _.extend({}, defaultConfig, conf);
        return false;
    }
});

export default config;